import { render } from "./markers.vue?vue&type=template&id=e88d473c"
import script from "./markers.vue?vue&type=script&lang=js"
export * from "./markers.vue?vue&type=script&lang=js"

import exportComponent from "/home/krupali/vuejs/borex-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__